import webuiState from "../app/InternalStateService";
import { WEBUILogs } from "@tinqin/tinqin-utils/src/logging";

const SET_GLOBAL_THEME = "SET_GLOBAL_THEME";

export function setThemeFromSirenAction(action) {
    let actionFields = action.fields ? action.fields : [];
    let theme =
        actionFields.find(function(field) {
            return field.name === "theme";
        }) || {};

    return setTheme(theme.value);
}

export function setTheme(themeId) {
    return dispatch => {
        let isLoaded = document.getElementById(themeId);

        //in case theme is already loaded
        if (isLoaded) {
            return dispatch({
                type: SET_GLOBAL_THEME,
                payload: {
                    theme: themeId
                }
            });
        }

        dispatch(webuiState.getActionByName("loading.triggerGlobalLoading")()); //trigger loader
        loadTheme(themeId).then(() => {
            dispatch(webuiState.getActionByName("loading.dismissGlobalLoading")()); // the request is done so we dismiss the loader
            dispatch({
                type: SET_GLOBAL_THEME,
                payload: {
                    theme: themeId
                }
            });
        });
    };
}

function loadTheme(themeId) {
    let urlPrefix = webuiState.getWebConfig()["ROOT_PATH"];
    //adding trailing "/" if missing
    if (!urlPrefix.endsWith("/")) {
        urlPrefix += "/";
    }

    return new Promise(resolve => {
        let link;
        //placeholder for adding theme's css in between other css
        let placeholder = document.getElementById("themePlaceholder");
        link = document.createElement("link");
        link.rel = "stylesheet";
        link.type = "text/css";
        //theme css is placed on the same level as bundle.css to avoid img/fonts reference issues
        //link.href = urlPrefix + "themes/" + themeId + ".css";
        link.href = urlPrefix + themeId + ".css";
        link.media = "all";
        link.id = themeId;

        link.addEventListener(
            "load",
            function() {
                // watching for the browser stylesheet to complete loading the file.
                // this may not work in Firefox 4 and under
                WEBUILogs.log("the stylesheet request is done");
                resolve();
            },
            false
        );

        document.head.insertBefore(link, placeholder);
    });
}
